import React, {useEffect} from 'react';
import {Route, Switch, useRouteMatch} from 'react-router';
import useDispatchWithResult from '../../../../hooks/useDispatchWithResult';
import {fetchContrato} from '../../../../store/empresa';
import EmpresaContratoCreatePage from './_create';
import EmpresaContratoDetailPage from './_detail';
import EmpresaContratoEditPage from './_edit';

export default function EmpresaContratoPage() {
  const dispatch = useDispatchWithResult();
  const match = useRouteMatch();
  const empresaId = match.params.empresaId;
  const id = match.params.id;

  useEffect(() => {
    dispatch(fetchContrato({empresaId, id}));
  }, [empresaId, id]);

  return (
      <Switch>
        <Route path="/*/empresas/:empresaId/contratos/:id/edit" component={EmpresaContratoEditPage} />
        <Route path="/*/empresas/:empresaId/contratos/create" component={EmpresaContratoCreatePage} />
        <Route path="/*/empresas/:empresaId/contratos/:id" component={EmpresaContratoDetailPage} />
      </Switch>);
}
